import netsImg from './nets-img';
import netsImgOnload from './nets-img-onload';
import netsPreventDefault from './nets-prevent-default';

export default angular
  .module('app.directives', [])
  .directive('netsImg', netsImg)
  .directive('netsImgOnload', netsImgOnload)
  .directive('netsPreventDefault', netsPreventDefault);
